import { createApp } from "vue";
import AlertModal from "../components/AlertModal.vue";
import { createVuetify } from "vuetify";
import i18n from "./i18n.js";

let alertComponentInstance = null;

// Function to create and mount the alert component
function createAlertComponent(options)
{
  if (!alertComponentInstance)
  {
    const div = document.createElement("div");
    document.body.appendChild(div);

    const app = createApp(AlertModal, {
      title: options.props.title,
      text: options.props.html,
      variant: options.props.icon,
      isOpen: true,
    });

    const vuetify = createVuetify();
    app.use(vuetify).use(i18n);
    alertComponentInstance = app.mount(div);
  } else
  {
    alertComponentInstance.modal.title = options.props.title;
    alertComponentInstance.modal.text = options.props.html;
    alertComponentInstance.modal.variant = options.props.icon;
    alertComponentInstance.modal.isOpen = true;
  }
  return alertComponentInstance;
}

export const AlertPlugin = {
  install: (app) =>
  {
    app.config.globalProperties.$showAlert = (options) =>
    {
      const alertApp = createAlertComponent({ props: options });
    };
  },
};
